import { RawFilters } from '@b2b/common/components/advanced-filters';
import { fromActor } from '@b2b/common/rxjs';
import { ApiService } from '@b2b/common/services/api/types';
import angular from 'angular';
import { createActor } from 'xstate';
import { customersIndividualsListMachine } from '../machines/customers-individuals-list.machine';
import { FetchCustomersProps } from '../types';

export class CustomersIndividualsListService {
  static $inject = ['ApiService'];

  private actor = this.createActor();
  state$ = fromActor(this.actor);

  constructor(private apiService: ApiService) {}

  getSnapshot() {
    return this.actor.getSnapshot();
  }

  /**
   * Since we're using a singleton service and AngularJS doesn't have an easy way to have
   * hierarchical injectors we need a way to reset the list state when navigating out of the
   * Customers Individuals List view/merge flow.
   *
   * @link https://acmeticketing.atlassian.net/browse/APP-2234
   */
  reset() {
    this.actor.send({ type: 'RESET' });
  }

  toggleMode() {
    this.actor.send({ type: 'TOGGLE_MODE' });
  }

  setBasicSearchState(searchQuery: string) {
    this.actor.send({ type: 'SET_BASIC_SEARCH_STATE', searchQuery });
  }

  setAdvancedSearchState(rawFilters: RawFilters) {
    this.actor.send({ type: 'SET_ADVANCED_SEARCH_STATE', rawFilters });
  }

  fetchCustomers() {
    this.actor.send({ type: 'FETCH_CUSTOMERS' });
  }

  fetchCustomersSuccess() {
    this.actor.send({ type: 'FETCH_CUSTOMERS_SUCCESS' });
  }

  fetchCustomersFailed() {
    this.actor.send({ type: 'FETCH_CUSTOMERS_FAILED' });
  }

  queryWithAdvancedSearch(props: Partial<FetchCustomersProps> & { rawFilters: RawFilters }) {
    const { rawFilters, ...rest } = props;

    return this.apiService.customers.advancedSearch({ ...rest, ...rawFilters }).then((response) => response.data);
  }

  private createActor() {
    return createActor(customersIndividualsListMachine).start();
  }
}

export const CustomersIndividualsListServiceModule = angular
  .module('acme.view.application.customers.individuals.list.service', ['acme.common.service.api'])
  .service('CustomersIndividualsListService', CustomersIndividualsListService).name;
